import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api/v1`;

export const getTotalChildren = createAsyncThunk('parentForm/getTotalChildren', async (_, { signal, rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/child?approved=true&isSponsored=false`, { signal });

    return response.data.totalApprovedChildren;
  } catch (error) {
    if (axios.isCancel(error)) {
      return rejectWithValue('Request cancelled');
    }
    return rejectWithValue(error.response?.data?.message || 'Sorry, something has gone wrong. Please contact an administrator..');
  }
});

export const submitParentFormToServer = createAsyncThunk(
  'parentForm/submitParentForm',
  async (data, { rejectWithValue }) => {
    const formData = {
      name: data.name,
      email: data.email,
      studentId: data.studentId,
      phone: data.phone,
      smsUpdate: data.smsUpdate,
      pickup: {
        pickupLocation: data.pickupLocation,
        additionalPerson: data?.additionalPerson,
      },
      children: data.children,
    };

    try {
      const response = await axios.post(`${API_URL}/parent`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Your form could not be submitted. Please contact an administrator.'
      );
    }
  }
);

const initialParentFormState = {
  values: {},
  loading: false,
  success: false,
  error: null,
  data: {},
  totalChildren: 0
};

const parentFormSlice = createSlice({
  name: 'parentForm',
  initialState: initialParentFormState,
  reducers: {
    setParentFormValues: (state, action) => {
      // Merge the existing state.values with the new values from the action payload
      state.values = { ...state.values, ...action.payload };
    },
    resetParentFormError: (state) => {
      state.error = null;
    },
    resetParentFormValues: (state) => {
      Object.assign(state, initialParentFormState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitParentFormToServer.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitParentFormToServer.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.success = true;
      })
      .addCase(submitParentFormToServer.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(getTotalChildren.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTotalChildren.fulfilled, (state, action) => {
        state.totalChildren = action.payload;
        state.loading = false;
      })
      .addCase(getTotalChildren.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { setParentFormValues, resetParentFormError, resetParentFormValues } = parentFormSlice.actions;

export default parentFormSlice.reducer;
